// Google reCAPTCHA v3 — graceful no-op when key is empty.
let installedSiteKey = null;
let loadPromise = null;

export const loadCaptcha = (siteKey) => {
    if (typeof window === "undefined") return Promise.resolve(false);
    const key = (siteKey || "").trim();
    if (!key) return Promise.resolve(false);
    if (installedSiteKey === key && loadPromise) return loadPromise;

    installedSiteKey = key;
    loadPromise = new Promise((resolve) => {
        const existing = document.querySelector("script[data-otp-recaptcha]");
        if (existing) {
            // already on page (likely same key) — wait for grecaptcha.ready
            if (window.grecaptcha) window.grecaptcha.ready(() => resolve(true));
            else resolve(true);
            return;
        }
        const s = document.createElement("script");
        s.async = true;
        s.defer = true;
        s.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(key)}`;
        s.setAttribute("data-otp-recaptcha", "true");
        s.onload = () => {
            if (window.grecaptcha) window.grecaptcha.ready(() => resolve(true));
            else resolve(false);
        };
        s.onerror = () => resolve(false);
        document.head.appendChild(s);
    });
    return loadPromise;
};

// Returns a v3 token or "" if captcha not available.
export const executeCaptcha = async (action = "submit") => {
    if (typeof window === "undefined" || !window.grecaptcha || !installedSiteKey) return "";
    try {
        return await window.grecaptcha.execute(installedSiteKey, { action });
    } catch {
        return "";
    }
};

export const isCaptchaConfigured = () => Boolean(installedSiteKey);
